import styled from 'styled-components';
import { mixins, colors, fonts } from '../../../../../css';
import { DEFAULT_BUTTON_BORDER_COLOR, PANEL_BUTTON_BORDER_WIDTH } from '../FiltersContainer.styles';
import Input from '../Input';
import Text from '../../../../../BuildingBlocks/Text';

const { pxToRem } = mixins;
const { colorBlue, colorWhite, colorGrey03Rgba, colorGrey02, colorGreyRgba, colorGrey05 } = colors;

export const PANEL_BUTTON_DATES_WIDTH = 250;
export const PANEL_BUTTON_ROOMS_WIDTH = 120;
export const PANEL_BUTTON_FILTERS_WIDTH = 150;
export const PANEL_BUTTON_PADDING = 20;
export const PANEL_BUTTON_HEIGHT = 55;
export const PANEL_TOP = 120;
export const PANEL_DISTANCE = 520;

export const Wrapper = styled.div`
  visibility: ${({ visible }) => (visible ? 'visible' : 'hidden')};
`;

export const Container = styled.div`
  position: relative;
  width: 100%;
  display: flex;
  align-items: left;
  flex-direction: column;
`;

const panelButton = styled.div`
  flex: 0 1 auto;
  height: ${pxToRem(PANEL_BUTTON_HEIGHT)};
  pointer-events: auto;
  background-color: ${colorWhite};
  border: ${PANEL_BUTTON_BORDER_WIDTH}px solid ${DEFAULT_BUTTON_BORDER_COLOR};
  padding: ${pxToRem(10)} ${pxToRem(PANEL_BUTTON_PADDING)};
  transition: border-color 125ms;
  ${({ selected }) => selected && `border-color: ${colorBlue} !important;`};

  .text {
    font-family: ${fonts.fontRegular};
    font-weight: bold;
    font-size: 16px;
    letter-spacing: -0.45px;
  }
`;

export const PanelButtonDates = styled(panelButton).attrs({
  size: 'sm',
  theme: 'white'
})`
  border-color: ${DEFAULT_BUTTON_BORDER_COLOR};
  width: 100%;
  cursor: pointer;
`;

export const PanelButtonRooms = styled(panelButton)`
  border-color: ${DEFAULT_BUTTON_BORDER_COLOR};
  border-left-width: 0px;
  border-right-width: 1px;
  width: 30%;
  ${({ selected }) =>
    selected &&
    `
      border-width: ${PANEL_BUTTON_BORDER_WIDTH}px;
      margin: 0px -${PANEL_BUTTON_BORDER_WIDTH}px;
      z-index: 1;
      width: 30%;
    `};
`;

export const PanelButtonFilters = styled.div`
  div {
    color: ${colorBlue};
  }
  margin-top: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
`;

export const Panel = styled.div`
  background: ${colorWhite};
  position: fixed;
  left: 25.25%;
  top: 263px;
  width: 25%;
  max-height: 53%;
  display: flex;
  visibility: ${({ showing }) => (showing ? 'visible' : 'hidden')};
  flex-direction: column;
  &:before {
    content: ' ';
    position: absolute;
    height: ${pxToRem(15)};
    width: ${pxToRem(15)};
    background: ${colorWhite};
    transform: rotate(45deg);
    top: ${pxToRem(11)};
    left: -1%;
  }
`;

export const PanelBody = styled.div`
  flex: 1 1 auto;
  overflow-y: auto;
  overflow-x: hidden;
  display: block;
  padding: ${pxToRem(3)} ${pxToRem(20)} 0;
`;

export const PanelFooter = styled.div`
  flex: 0 0 ${pxToRem(96)};
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-shadow: 0px -1px 1px 0px ${colorGrey03Rgba(0.2)};
  padding: ${pxToRem(20)};

  button:first-of-type {
    position: relative;
    margin-right: ${pxToRem(20)};
  }
`;

export const PanelRooms = styled.div`
  > div {
    top: auto;
  }
  top: 96px;
  left: 25.25%;
  background: ${colorWhite};
  position: fixed;
  width: 10%;
  display: flex;
  visibility: ${({ showing }) => (showing ? 'visible' : 'hidden')};
  background-color: ${colorGrey02};
  &:before {
    background: ${colorGrey02};
  }
  flex-direction: column;
  &:before {
    content: ' ';
    position: absolute;
    height: ${pxToRem(15)};
    width: ${pxToRem(15)};
    background: ${colorGrey02};
    transform: rotate(45deg);
    top: ${pxToRem(11)};
    left: -3%;
  }
`;

export const PanelBodyRooms = styled.div`
  flex: 0 1 auto;
  padding: ${pxToRem(20)};
`;

export const RoomsInput = styled(Input)`
  width: 100%;
  margin: 0;
`;

export const DatesRoomsContainer = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  flex-wrap: wrap;
`;

export const PriceRangeContainer = styled.div`
  display: flex;
  height: 27px;
  justify-content: space-between;
`;

export const PriceRangeInputContainer = styled.div`
  display: flex;
  width: 30%;
  flex: 1 0 30%;
  align-items: center;
  > span {
    font-size: 1.5rem;
  }
`;

export const StyledInput = styled(Input)`
  flex: 0 0 35%;
  width: 35%;
`;

export const DistanceInput = styled(Input)`
  width: ${pxToRem(60)};
`;

export const Backdrop = styled.div`
  pointer-events: auto;
  background: ${colorGreyRgba(0.15)};
  height: 100%;
  width: 100%;
  position: fixed;
  left: 0px;
  top: 80px;
`;

export const DisclaimerSection = styled.div`
  display: flex;
  height: ${pxToRem(52)};
  align-items: center;
  justify-content: center;
  background: ${colorGrey05};
`;

export const RoomsLabel = styled(Text.CopyMini)`
  margin-bottom: -1px;
`;

export const DescriptionContainer = styled.div`
  height: 70px;
  padding: 10px 10px 0 10px;
  width: 100%;
`;

export const PriceSectionContainer = styled.div`
  height: 70px;
  padding: 10px 0 0 10px;
  width: 50%;
`;

export const FiltersSectionContainer = styled.div`
  height: 100%;
  display: flex;
  margin-top: 10px;
`;
